module.exports = __webpack_public_path__ + "img/loader.98abe9fc.gif";